export const clipCardVertexShader = /* glsl */ `
    varying vec2 vUv;
    void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
`;

export const clipCardFragmentShader = /* glsl */ `
    uniform sampler2D uThumbnail;
    uniform vec3 uBorderColor;
    uniform float uBorderWidth;
    uniform float uCornerRadius;
    uniform float uOpacity;
    uniform float uTexAspect;

    varying vec2 vUv;

    float sdRoundedBox(vec2 p, vec2 b, float r) {
        vec2 q = abs(p) - b;
        return length(max(q, 0.0)) + min(max(q.x, q.y), 0.0) - r;
    }

    void main() {
        vec2 p = (vUv - 0.5) * 2.0;
        float r = uCornerRadius;
        float bw = uBorderWidth;

        float dOuter = sdRoundedBox(p, vec2(1.0 - r), r);
        float dInner = sdRoundedBox(p, vec2(1.0 - r - bw), max(r - bw, 0.01));

        float aa = 0.04;
        float outerAlpha = smoothstep(aa, 0.0, dOuter + .04);
        float inBorder = smoothstep(-aa, aa, dInner) * step(dOuter, 0.0);

        float a = outerAlpha * uOpacity;
        if (a < 0.01) discard;

        vec2 coverUv = vUv;
        if (uTexAspect > 1.0) {
            coverUv.x = (vUv.x - 0.5) * (1.0 / uTexAspect) + 0.5;
        } else if (uTexAspect < 1.0) {
            coverUv.y = (vUv.y - 0.5) * uTexAspect + 0.5;
        }

        vec4 tex = texture2D(uThumbnail, coverUv);
        vec3 color = mix(tex.rgb, uBorderColor, inBorder);
        gl_FragColor = vec4(color, a);
    }
`;
